"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                GlobalSearchPlaceholder_Navigation: "Search for a page",
                Search_SelectPage: "Go to the selected page",
            }
        });
        var CombinedNavigationSearch = /** @class */ (function (_super) {
            __extends(CombinedNavigationSearch, _super);
            function CombinedNavigationSearch() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CombinedNavigationSearch.prototype.Placeholder = function () {
                return $dyn.label("GlobalSearchPlaceholder_Navigation");
            };
            CombinedNavigationSearch.prototype.TextChanged = function (args) {
                if (args[0] !== "") {
                    $(this.element.parentNode).addClass("combinedSearch-field-no-placeHolder");
                }
                var searchField = this.SearchField;
                if (searchField.textChangedTimerId) {
                    window.clearTimeout(searchField.textChangedTimerId);
                    searchField.textChangedTimerId = undefined;
                }
                searchField.textChangedTimerId = window.setTimeout(function () {
                    searchField.DoNavigationSearch(args[0]);
                    searchField.textChangedTimerId = undefined;
                }, 200);
            };
            CombinedNavigationSearch.prototype.clickItem = function (resultIndex) {
                var resultList = $dyn.value(this.ResultList);
                if (resultIndex < resultList.length) {
                    this.NavigateToResult(resultList[resultIndex]);
                }
            };
            CombinedNavigationSearch.prototype.NavigateToResult = function (result) {
                // Telemetry
                this.navigationToResultEvent(result);
                // Prevent blinking
                this.closeResultPicker();
                // route navigation through the navigation pane
                var navItem = this.createNavigationContext(result);
                $dyn.DynReact.ModuleStore.startNavigation(navItem);
            };
            CombinedNavigationSearch.prototype.DoNavigationSearch = function (query) {
                var _this = this;
                query = query.trim();
                var isDoubleByte = $dyn.util.stringHasDoubleByte(query);
                if ((!isDoubleByte && query.length < 3) || (isDoubleByte && query.length < 2)) {
                    this.ResultList([]);
                    this.lastQuery = query;
                    return;
                }
                if (this.lastQuery && this.lastQuery === query) {
                    return;
                }
                var ajaxSent = performance.now();
                this.sendQueryRequest(query, function (data) {
                    var e_1, _a;
                    _this.currentSearchTelemetryInfo = { ResponseTime: performance.now() - ajaxSent, Query: query };
                    var results = [];
                    try {
                        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                            var item = data_1_1.value;
                            var path = item.Path;
                            if (path.length > 0) {
                                var name_1 = path.pop();
                                if (item.Source.toUpperCase() === _this._mainMenu.toUpperCase()) {
                                    // remove "Main Menu"
                                    path.shift();
                                }
                                else if (item.Source.toUpperCase() === _this._workspaceMenu.toUpperCase()) {
                                    path[0] = $dyn.label("NavigationPane_Workspaces");
                                }
                                var pathString = $dyn.shell.joinArrayWithChevron(path);
                                results.push({ Label: name_1, Path: pathString, Tag: item.ItemDescription, AOTPath: item.AOTPath });
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    _this.lastQuery = query;
                    _this.ResultList(results);
                    _this.openResultPicker();
                });
            };
            CombinedNavigationSearch.prototype.sendQueryRequest = function (query, callback) {
                var url = "/navigationsearch/dosearch?query=" + encodeURIComponent(query) +
                    ("&numberOfResults=" + this._numberOfResults.toString()) +
                    ("&rootMenu=" + this._mainMenu) +
                    ("&rootMenu=" + this._workspaceMenu);
                // tslint:disable:object-literal-sort-keys
                $.ajax({
                    url: $dyn.util.resolveVirtualPath(url),
                    type: "GET",
                    cache: false,
                    beforeSend: function (request) {
                        $dyn.serverForm.setCsrfToken(request);
                        var activityKey = $dyn.util.newGuid();
                        request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                        request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.activityKey, activityKey);
                        $dyn.browserActivity && $dyn.browserActivity.newInteraction(activityKey);
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("CombinedNavigationSearch");
                        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax(activityKey);
                    }
                }).done(function (data) {
                    callback(data);
                }).always(function () {
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                });
                // tslint:enable:object-literal-sort-keys
            };
            CombinedNavigationSearch.prototype.createNavigationContext = function (result) {
                // Creates a object that NavPane recognizes
                var menuItemParts = result.Tag.split(":");
                var navItem = {
                    Label: result.Name,
                    MenuItemName: menuItemParts[1],
                    MenuItemType: menuItemParts[0],
                    navigationFeatureName: "searchbox",
                    NavigationPath: result.AOTPath,
                };
                return navItem;
            };
            CombinedNavigationSearch.prototype.navigationToResultEvent = function (result) {
                if (this.currentSearchTelemetryInfo) {
                    var resultIndex = $dyn.value(this.ResultList).indexOf(result);
                    $dyn.telemetry.addNavigationSearchEvent(this.currentSearchTelemetryInfo.ResponseTime, this.currentSearchTelemetryInfo.Query, resultIndex, result.Tag);
                    this.currentSearchTelemetryInfo = undefined;
                }
            };
            return CombinedNavigationSearch;
        }(controls.CombinedSearchField));
        controls.CombinedNavigationSearch = CombinedNavigationSearch;
        // tslint:disable:no-string-literal
        CombinedNavigationSearch.prototype["_numberOfResults"] = 10;
        CombinedNavigationSearch.prototype["_mainMenu"] = "MainMenu";
        CombinedNavigationSearch.prototype["_workspaceMenu"] = "NavPaneMenu";
        // tslint:enable:no-string-literal
        // tslint:disable:object-literal-sort-keys
        var navigationSearchShortcuts = {
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () {
                    if ($dyn.value(this.ShowResultPicker)) {
                        var selectedIndex = $dyn.value(this.SelectedIndex);
                        this.clickItem(selectedIndex);
                    }
                },
                RecordTelemetry: false,
                ShowToUser: function () { return $dyn.value(this.ShowResultPicker); },
                Description: $dyn.label("Search_SelectPage")
            }
        };
        CombinedNavigationSearch.prototype.Shortcuts = $dyn.extendPrototype(CombinedNavigationSearch.prototype.Shortcuts, navigationSearchShortcuts);
        $dyn.adapter({ id: "CombinedNavigationSearch", template: "CombinedSearchField" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=CombinedNavigationSearch.js.map
